import React from 'react';
import { NavLink } from 'react-router-dom';

const Navigation = props => (
  <div className="bussiness-main-menu-1x" style={{ borderTop: '4px solid #e64d5b' }}>
    <div className="container">
      <div className="row">
        <div className="col-md-12">
          <div className="business-main-menu">
            <nav className="navbar navbar-expand-lg navbar-light bg-light btco-hover-menu">
              <a className="navbar-brand" href="/">
                <img src="/images/logo-red.jpg" className="d-inline-block align-top" alt="" />
              </a>
              <button
                className="navbar-toggler"
                type="button"
                data-toggle="collapse"
                data-target="#navbarSupportedContent"
                aria-controls="navbarSupportedContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon" />
              </button>

              <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                  {props.navigation.map(nav => (
                    <li className="nav-item" key={nav.name}>
                      <NavLink to={nav.link} exact activeClassName="active" className="nav-link">
                        {nav.name}
                      </NavLink>
                    </li>
                  ))}
                </ul>
              </div>
            </nav>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default Navigation;



// WEBPACK FOOTER //
// ./src/components/Navigation.js